import { SubmitInitiators } from '@cashier/cashier-model';

import { useCashierConfiguration } from './useCashierConfiguration';

export const useProcessingInitiator = () => {
  const { submitInitiator } = useCashierConfiguration();

  const isCashierInitiator = submitInitiator === SubmitInitiators.Self;
  const isPlatformInitiator = submitInitiator === SubmitInitiators.Parent;

  return {
    isCashierInitiator,
    isPlatformInitiator,
  };
};
